//  统计sdk与sdk服务端接口请求相差较大，独立出来方便维护
import axios from 'axios';
import { getSignStatis, getPhpNow, getUrlParams } from '@/utils';
import store from '@/store';
export function http({url = '', type = 'get', params = {}}) {
  let randDate = String(new Date().valueOf()) + 'RD' + Math.floor((Math.random()*10000000)+1);
  const host = window.location.host;
  let statis_url = getTopDomain(`https://${host}`, 'sdk-statis') + url;
  let axiosUrl = process.env.NODE_ENV === "production" ? `${statis_url}` : `/statisApi${url}`
  // url = `/statisApi${url}`
  let config = {
    method: type,
    url: axiosUrl,
    data: params
  }
  if (type === 'get') {
    config.params = params
  }
  if (type == 'post') {
    // config.data = qs.stringify(params)
  }
  // 设置header
  axios.defaults.headers['Content-Type'] = 'application/json';
  axios.defaults.headers['RequestId'] = randDate;
  axios.defaults.headers['ApiSignType'] = 'MD5';
  axios.defaults.headers['ApiSign'] = get_api_sign(params, randDate);
  axios.interceptors.request.use(configs => {
    return configs
  }, error => { // 错误处理
    return Promise.reject(error)
  })

  return axios(config)
}

function get_api_sign(data, randDate) {
 const sign_params = {
  series_id: store.state.series_id,
  package_version: parseInt(getUrlParams('ver') || 0),
  campaign: getUrlParams('campaign_id') || '',
  event: data.event,
  game_id: parseInt(getUrlParams('game_id') || 0),
  fu_appid: parseInt(getUrlParams('appid') || 0),
  package_name: getUrlParams('package_name') || 'h5',
  sdk_channel: getUrlParams('sdk_channel') || 'leniu',
  game_zone_id: store.state.zoneId || '',
  is_charge: getUrlParams('is_charge') || 0,
  network: getUrlParams('network') || 0,
  time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
  request_id: randDate,
 }
 return getSignStatis('U2FE89pOYCgSl2Z0ngFOxZQ=', sign_params)
}
// 主体域名解析
function getTopDomain(url, secondDomain) {
  try {
    const domain = url.replace(/^https?:\/\//, '').split('/')[0];
    const domainParts = domain.split('.');
    const baseDomain = domainParts.slice(domainParts.length - 2).join('.');
    const newDomain = 'https://' + secondDomain  + '.' + baseDomain;
    return newDomain 
  } catch (error) {
    return 'https://' + secondDomain  + '.' + 'leteng5.cn';
  }
}